export default __webpack_public_path__ + "static/media/type 8.2f883c60.jpg";